const ModalOverlay = () => {

     return (<div className={`fixed inset-0 z-30 bg-slate-200 dark:bg-slate-600 bg-opacity-50 dark:bg-opacity-50 backdrop-blur-sm`}></div>)
}

export default ModalOverlay